import styled from "styled-components";

export const Wrap = styled.div`
	height: min-content;
	top: 120px;
	padding: 10%;
	display: flex;
	justify-content: center;
	width: 100%;
	box-sizing: border-box;

	@media (min-width: 768px) {
		position: ${({ $sticky }) => ($sticky ? "sticky" : "relative")};
	}

	@media (max-width: 768px) {
		padding: 5% 10%;
		max-width: 400px;
	}
`;

export const Phone = styled.div`
	position: relative;
	width: 100%;
	max-width: 340px;
	aspect-ratio: 9 / 19.5;
	filter: drop-shadow(0 22px 40px rgba(0, 0, 0, 0.22));
`;

export const Bezel = styled.div`
	position: absolute;
	inset: 0;
	padding: 1.9%;
	border-radius: 14% / 6.5%;
	background: linear-gradient(160deg, #5a5a60 0%, #1a1a1c 32%, #0b0b0c 72%, #3a3a3e 100%);
	box-shadow:
		inset 0 1px 0 rgba(255, 255, 255, 0.28),
		inset 0 -1px 0 rgba(255, 255, 255, 0.06),
		0 0 0 1px rgba(0, 0, 0, 0.45);
`;

export const Screen = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: #000;
	border-radius: 12.4% / 5.75%;
`;

export const Media = styled.div`
	position: relative;
	width: 100%;
	height: 100%;

	img,
	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`;

export const SideBtn = styled.span`
	position: absolute;
	z-index: 1;
	background: linear-gradient(90deg, #2c2c2e, #111);
	border-radius: 1px;

	${({ $side }) =>
		$side === "left"
			? `
		left: -3px;
		width: 3px;
	`
			: `
		right: -3px;
		width: 3px;
	`}

	${({ $kind }) => {
		if ($kind === "silent") {
			return `
				top: 14.5%;
				height: 3.2%;
			`;
		}
		if ($kind === "vol-up") {
			return `
				top: 20.5%;
				height: 6.2%;
			`;
		}
		if ($kind === "vol-down") {
			return `
				top: 28%;
				height: 6.2%;
			`;
		}
		return `
			top: 22%;
			height: 9%;
		`;
	}}
`;
